import { useState, useEffect } from "react";
import { useI18nRefresh } from "../../../hooks/useI18nRefresh";

export interface UseChooseAnotherDateProps {
  selectedDate: string | Date | undefined;
  setSelectedDate: (date: string | Date) => void;
}

export interface UseChooseAnotherDateReturn {
  open: boolean;
  openCalendarModal: () => void;
  handleDateChange: (date: string | Date) => void;
  handleClose: () => void;
}

export function useChooseAnotherDate({
  selectedDate,
  setSelectedDate,
}: UseChooseAnotherDateProps): UseChooseAnotherDateReturn {
  const i18nRefresh = useI18nRefresh() as {
    checkAndRefreshI18n?: () => Promise<boolean>;
  };
  const [open, setOpen] = useState(false);

  // Check and refresh i18n when component mounts or when coming back online
  useEffect(() => {
    const checkTranslations = async () => {
      if (i18nRefresh?.checkAndRefreshI18n) {
        await i18nRefresh.checkAndRefreshI18n();
      }
    };

    checkTranslations();
  }, [i18nRefresh]);

  const openCalendarModal = () => setOpen(true);

  const handleDateChange = (date: string | Date) => {
    setSelectedDate(date);
  };

  const handleClose = () => setOpen(false);

  return {
    open,
    openCalendarModal,
    handleDateChange,
    handleClose,
  };
}
